import { Box, useTheme } from '@mui/material';
import Collapsible from 'components/collapsible';
import Divider from 'components/divider';
import { FormattedMessage, useIntl } from 'react-intl';

const PAGE_NAME_ID = 'orderFeed.ofdMySupplyPlan.inputSettings.feedInventoryTab.dialog';

const FeedInventoryExplanation = () => {
  const intl = useIntl();
  const theme = useTheme();

  return (
    <Box display={'flex'} flexDirection={'column'} gap={4}>
      <Divider variant="middle" flexItem dark />
      <Collapsible label={intl.formatMessage({ id: `${PAGE_NAME_ID}.title` })} hideBorder open={true}>
        <FormattedMessage id={`${PAGE_NAME_ID}.explanation`} />
      </Collapsible>
    </Box>
  );
};

export default FeedInventoryExplanation;
